// Exit Strategy options are scoped to the loan's Product Type.
//
//   Fix & Flip (Fix and Flip)          → Rehab to sell / Rehab to rent
//   Bridge (Stabilized / Multifamily)  → Bridge to sell / Bridge to rent /
//                                         Bridge to construction (permitting approval)
//   GUC (Ground Up Construction)       → Build to sell / Build to rent
//
// Any other product type has no predefined options. When an existing loan
// already holds an exitStrategy value that isn't in the list for its current
// product type, that legacy value is appended to the end of the dropdown so it
// stays selectable/visible — and disappears once the user picks a real option.

const REHAB_OPTIONS = ["Rehab to sell", "Rehab to rent"];
const BRIDGE_OPTIONS = [
  "Bridge to sell",
  "Bridge to rent",
  "Bridge to construction (permitting approval)",
];
const BUILD_OPTIONS = ["Build to sell", "Build to rent"];

// Keyed by the canonical `loanProductType` values stored on the loan.
export const EXIT_STRATEGY_OPTIONS_BY_PRODUCT_TYPE = {
  "Fix and Flip": REHAB_OPTIONS,
  "Stabilized Bridge": BRIDGE_OPTIONS,
  "Multifamily Bridge": BRIDGE_OPTIONS,
  "Ground Up Construction": BUILD_OPTIONS,
};

// Product types for which Exit Strategy is not applicable — the field is hidden
// entirely (not just emptied).
export const EXIT_STRATEGY_HIDDEN_PRODUCT_TYPES = ["DSCR", "Other"];

export const isExitStrategyHidden = (productType) =>
  EXIT_STRATEGY_HIDDEN_PRODUCT_TYPES.includes(productType);

/**
 * Returns the Exit Strategy options for a given product type. If `currentValue`
 * is a non-empty value that isn't one of the product type's options, it is
 * appended to the end so the existing (legacy/invalid) value stays visible in
 * the dropdown until the user changes it.
 */
export const getExitStrategyOptions = (productType, currentValue) => {
  const base = EXIT_STRATEGY_OPTIONS_BY_PRODUCT_TYPE[productType] || [];

  if (currentValue && !base.includes(currentValue)) {
    return [...base, currentValue];
  }

  return base;
};
